import * as trace from 'owa-trace';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getUserTimeZone } from 'owa-session-store';
import { owaDate } from 'owa-datetime';
import type { OwaDate } from 'owa-datetime';

export const getFirstOWAReactMiniLogon = (): OwaDate => {
    const firstOWAReactMiniLogonString =
        getUserConfiguration()?.UserOptions?.FirstOWAReactMiniLogon;

    try {
        if (!firstOWAReactMiniLogonString) {
            return null;
        }

        const firstLogonDate = new Date(firstOWAReactMiniLogonString);
        if (isNaN(firstLogonDate.getTime())) {
            return null;
        }

        const tz = getUserTimeZone();
        const firstOWAReactMiniLogon = owaDate(tz, firstLogonDate.toISOString());

        return firstOWAReactMiniLogon;
    } catch (error) {
        trace.errorThatWillCauseAlert(
            'Error in getFirstOWAReactMiniLogon, firstOWAReactMiniLogon: ' +
                firstOWAReactMiniLogonString +
                ' error: ' +
                error.message,
            error
        );
        return null;
    }
};
